<template>
  <lazy-dom>
    <section class="dashboard-container">
      <div class="dashboard-header">
        <div class="dashboard-icon">
          <img
            src="../../assets/dasboard.svg"
            alt="">
          <span>Dashboard</span>
        </div>
        <div class="dashboard-time">{{nowTime}}</div>
        <div
          class="button"
          @click="handlerOpen">
          <span>{{searchName}}</span>
          <i class="el-icon-arrow-down"></i>
        </div>
      </div>
      <el-row
        align="center"
        :gutter="49"
        class="row-bg"
      >
        <v-row-col
          :xs="11"
          :sm="11"
          :md="6"
          :lg="6"
          :xl="6"
        >
          <div
            class="type-box card"
            align="center"
          >
            <span class="type-label">Unique Visitors
            </span>
            <div class="type-count">
              <!--<span class="num">{{unique_visitors.total}}</span>-->
              <span class="num">TBC</span>
            </div>
            <div class="type-bottom">
              <div v-if="unique_visitors.diff>0">
                <span class="icon-circle-up">
                  <font-awesome-icon icon="arrow-circle-up"/>
                </span>
                <span class="update-num">{{unique_visitors.diff}}</span>
              </div>
              <div v-if="unique_visitors.diff<0">
                <span class="icon-circle-up-warn">
                  <font-awesome-icon icon="arrow-circle-down"/>
                </span>
                <span class="update-num-warm">{{unique_visitors.diff}}</span>
              </div>
            </div>
          </div>
        </v-row-col>
        <v-row-col
          :xs="11"
          :sm="11"
          :md="6"
          :lg="6"
          :xl="6"
        >
          <div
            class="type-box card"
            align="center"
          >
            <span class="type-label">Policies</span>
            <div class="type-count">
              <span class="num">{{policies.total}}</span>
            </div>
            <div class="type-bottom">
              <div v-if="policies.diff>0">
                <span class="icon-circle-up">
                  <font-awesome-icon icon="arrow-circle-up"/>
                </span>
                <span class="update-num">{{policies.diff_format}}</span>
              </div>
              <div v-if="policies.diff<0">
                <span class="icon-circle-up-warn">
                  <font-awesome-icon icon="arrow-circle-down"/>
                </span>
                <span class="update-num-warm">{{policies.diff_format}}</span>
              </div>
            </div>
          </div>
        </v-row-col>
        <v-row-col
          :xs="11"
          :sm="11"
          :md="6"
          :lg="6"
          :xl="6"
        >
          <div
            class="type-box card"
            align="center"
          >
            <span class="type-label">Quick Quote (Product Listing)
            </span>
            <div class="type-count">
              <span class="num">{{quick_quote_clicks.total}}</span>
            </div>
            <div class="type-bottom">
              <div v-if="quick_quote_clicks.diff>0">
                <span class="icon-circle-up">
                  <font-awesome-icon icon="arrow-circle-up"/>
                </span>
                <span class="update-num">{{quick_quote_clicks.diff}}</span>
              </div>
              <div v-if="quick_quote_clicks.diff<0">
                <span class="icon-circle-up-warn">
                  <font-awesome-icon icon="arrow-circle-down"/>
                </span>
                <span class="update-num-warm">{{quick_quote_clicks.diff}}</span>
              </div>
            </div>
          </div>
        </v-row-col>
        <v-row-col
          :xs="11"
          :sm="11"
          :md="6"
          :lg="6"
          :xl="6"
        >
          <div
            class="type-box card"
            align="center"
          >
            <span class="type-label">Gross Written Premium</span>
            <div class="type-count">
              <!--<span class="num">{{grossWrittenPemium.total}}</span>-->
              <span class="num">TBC</span>
            </div>
            <div class="type-bottom">
              <!--
              <div v-if="grossWrittenPemium.diff>0">
                <span class="icon-circle-up">
                  <font-awesome-icon icon="arrow-circle-up"/>
                </span>
                <span class="update-num">{{grossWrittenPemium.diff_format}}</span>
              </div>
              <div v-if="grossWrittenPemium.diff<0">
                <span class="icon-circle-up-warn">
                  <font-awesome-icon icon="arrow-circle-down"/>
                </span>
                <span class="update-num-warm">{{grossWrittenPemium.diff_format}}</span>
              </div>
              -->
            </div>
          </div>
        </v-row-col>
        <v-row-col
          :xs="11"
          :sm="11"
          :md="6"
          :lg="6"
          :xl="6"
        >
          <div
            class="type-box card"
            align="center"
          >
            <span class="type-label">Account</span>
            <div class="type-count">
              <span class="num">{{account.total||0}}</span>
            </div>
            <div class="account-ul-color type-bottom">
              <div class="little-num">
                <span
                  v-if="account.pending_total>0"
                  class="white">({{account.pending_total}})</span>
                <span
                  v-for="(item,index) in account.all"
                  :key="'s'+index"
                  :class="{'green': item.identity == 1, 'blue': item.identity == 2}"
                >
                  {{getOptionName('userTypeOptions',item.identity)}} : {{item.nums}}
                </span>
              </div>
              <ul>
                <li
                  v-for="(item,index) in account.all"
                  :key="index"
                  :style="'width:' +(item.nums/account.total)*100+'%'"
                >
                  <span class="red"></span>
                </li>
              </ul>
            </div>
          </div>
        </v-row-col>
        <v-row-col
          :xs="11"
          :sm="11"
          :md="6"
          :lg="6"
          :xl="6"
        >
          <div
            class="type-box card"
            align="center"
          >
            <span class="type-label">Covid-19 Protector</span>
            <div class="type-count">
              <span class="num">{{covids.total}}</span>
            </div>
            <div class="type-bottom">
              <div v-if="covids.diff>0">
                <span class="icon-circle-up">
                  <font-awesome-icon icon="arrow-circle-up"/>
                </span>
                <span class="update-num">{{covids.diff_format}}</span>
              </div>
              <div v-if="covids.diff<0">
                <span class="icon-circle-up-warn">
                  <font-awesome-icon icon="arrow-circle-down"/>
                </span>
                <span class="update-num-warm">{{covids.diff_format}}</span>
              </div>
            </div>
          </div>
        </v-row-col>
        <v-row-col
          :xs="11"
          :sm="11"
          :md="6"
          :lg="6"
          :xl="6"
        >
          <div
            class="type-box card"
            align="center"
          >
            <span class="type-label">Issuing Policies</span>
            <div class="type-count">
              <span class="num">{{issuingPolicies.total}}</span>
            </div>
            <div class="type-bottom"></div>
          </div>
        </v-row-col>
        <v-row-col
          :xs="11"
          :sm="11"
          :md="6"
          :lg="6"
          :xl="6"
        >
          <div
            class="type-box card"
            align="center"
          >
            <span class="type-label">Alive Tickets</span>
            <div class="type-count">
              <span class="num">{{unread_tickets.total}}</span>
            </div>
            <div class="type-bottom"></div>
          </div>
        </v-row-col>
        <v-row-col
          :xs="11"
          :sm="11"
          :md="6"
          :lg="6"
          :xl="6"
        >
          <div
            class="type-box card"
            align="center"
          >
            <span class="type-label">Unsettled Claims</span>
            <div class="type-count">
              <span class="num">{{unsettle_claims.total}}</span>
            </div>
            <div class="type-bottom"></div>
          </div>
        </v-row-col>
        <v-row-col
          :xs="11"
          :sm="11"
          :md="6"
          :lg="6"
          :xl="6"
        >
          <div
            class="type-box card"
            align="center"
          >
            <span class="type-label">Issued Hold Dollars</span>
            <div class="type-count">
              <span
                class="num">{{issuedHoldDollars.total}}</span>
            </div>
            <div class="type-bottom"></div>
          </div>
        </v-row-col>
        <v-row-col
          :xs="11"
          :sm="11"
          :md="6"
          :lg="6"
          :xl="6"
        >
          <div
            class="type-box card"
            align="center"
          >
            <span class="type-label">Cryptocurrency Exchange
            </span>
            <div class="type-count">
              <span class="num">{{cryptocurrency_exchange.total}}</span>
            </div>
            <div class="type-bottom"></div>
          </div>
        </v-row-col>
        <v-row-col
          :xs="11"
          :sm="11"
          :md="6"
          :lg="6"
          :xl="6"
        >
          <div
            class="type-box card"
            align="center"
          >
            <span class="type-label">On Duty Staff</span>
            <div class="type-count">
              <span class="flex wrap">
                <span
                  v-for="(item,index) in on_duty_staff.data"
                  :key="'a'+index"
                  class="on-duty-size">{{item}}&nbsp;</span>
              </span>
            </div>
            <div class="type-bottom"></div>
          </div>
        </v-row-col>
      </el-row>
      <dashboard-search
        ref="dashboardSearch"
        @handlerTime="handlerTime"></dashboard-search>
    </section>
  </lazy-dom>
</template>
<script>
import dashboardSearch from './components/dashboardSearch'
import dayjs from 'dayjs'
import { getNewDashboard } from '@/api/dashboard'
import MixinOptions from '@/mixins/options'

export default {
  name: 'dashboardPage',
  components:{
    dashboardSearch
  },
  mixins: [MixinOptions],
  data() {
    return {
      dashboardData: {},
      timer: null,
      nowTime:'',
      timeNow: null,
      date:new Date(),
      searchData:{
        type:1
      }
    }
  },
  computed:{
    searchName(){
      let {type} = this.searchData||{}
      let name = {
        1:'Today',
        2:'Period',
        3:'Monthly',
        4:'Year'
      }
      return name[type]
    },
    account() {
      const { accounts = {} } = this.dashboardData
      return accounts
    },
    pendingNum(){
      let {pending=[]}=this.account
      let num = 0
      pending.forEach(item=>{
        num = Number(item.nums)+num
      })
      return num
    },
    personalNum(){
      let {pending=[]}=this.account
      let num = 0
      pending.forEach(item=>{
        num = Number(item.nums)+num
      })
      return num
    },
    bankQueue() {
      const { bank_queue = {} } = this.dashboardData
      return bank_queue
    },
    covids() {
      const { covids = {} } = this.dashboardData
      return covids
    },
    grossWrittenPemium() {
      const { gross_written_premium = {} } = this.dashboardData
      return gross_written_premium
    },
    issuedHoldDollars() {
      const { issued_hold_dollars = {} } = this.dashboardData
      return issued_hold_dollars
    },
    issuingPolicies() {
      const { issuing_policies = {} } = this.dashboardData
      return issuing_policies
    },
    cryptocurrency_exchange() {
      const { cryptocurrency_exchange = {} } = this.dashboardData
      return cryptocurrency_exchange
    },
    on_duty_staff() {
      const { on_duty_staff = {} } = this.dashboardData
      return on_duty_staff
    },
    policies() {
      const { policies = {} } = this.dashboardData
      return policies
    },
    unique_visitors() {
      const { unique_visitors = {} } = this.dashboardData
      return unique_visitors
    },
    quick_quote_clicks() {
      const { quick_quote_clicks = {} } = this.dashboardData
      return quick_quote_clicks
    },
    quotes() {
      const { quotes = {} } = this.dashboardData
      return quotes
    },
    unread_tickets() {
      const { unread_tickets = {} } = this.dashboardData
      return unread_tickets
    },
    unsettle_claims() {
      const { unsettle_claims = {} } = this.dashboardData
      return unsettle_claims
    },
  },
  created() {
    this.network().getDashboard()
    this.startTime()
    this.timer = setInterval(() => {
      this.network().getDashboard()
    }, 60000)

  },
  destroyed() {
    clearInterval(this.timer)
    clearInterval(this.timeNow)
  },
  methods: {
    startTime(){
      let time = new Date()
      this.nowTime =  dayjs(time).format('DD MMM YYYY HH:mm:ss')
      this.timeNow = setInterval(() => {
        let time = new Date()
        this.nowTime =  dayjs(time).format('DD MMM YYYY HH:mm:ss')
      }, 1000)
    },
    handlerOpen(){
      this.$refs.dashboardSearch.changeDialog()
    },
    handlerTime(data){
      clearInterval(this.timeNow)
      switch(data.type){
        case '1':
          this.startTime()
          break
        case '2':
          this.nowTime = `${data.date[0] + ' - ' + data.date[1]}`
          break
        case '3':
          this.nowTime = data.month
          break
        case '4':
          this.nowTime = data.year
          break
        default:
          break
      }
      this.searchData = data
      this.network().getDashboard()
    },
    network() {
      return {
        getDashboard: async () => {
          this.date = dayjs(this.date).format('YYYY-MM-DD')
          let {type,date='',month='',year} =this.searchData||{}
          let params = {
            type:type
          }
          if(type ==2){
            params.start_time =date? dayjs(date[0]).format('YYYY-MM-DD'):''
            params.end_time =date? dayjs(date[1]).format('YYYY-MM-DD'):''
          }
          if(type ==3){
            params.month =month?dayjs(month).format('YYYY-MM'):''
          }
          if(type ==4){
            params.year =year?dayjs(year).format('YYYY'):''
          }
          params.hideLoading=true
          const { data } = await getNewDashboard(params)
          this.dashboardData = data
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  ::-webkit-scrollbar {
    display: none;
  }
  .dashboard-container {
    background: #000000;
    width: 100%;
    height: 100vh;
    overflow-y: scroll;
    padding: 20px;

    .dashboard-header{
      margin-bottom: 60px;
      margin-top: 40px;
      display: flex;
      color: #fff;
      padding: 0 29px;
      justify-content: space-between;
      align-items: center;
      .dashboard-icon{
        display: flex;
        align-items: center;
        color: #fff;
        span{
          font-family: Inter;
          font-style: normal;
          font-weight: 600;
          font-size: 32px;
          line-height: 48px;
          margin-left: 25px;
        }
      }
      .dashboard-time{
        font-family: Inter;
        font-feature-settings: 'tnum' on, 'lnum' on, 'zero' on, 'ss01' on;
        font-style: normal;
        font-weight: normal;
        font-size: 24px;
        line-height: 29px;
        color: #fff;
      }
      .button{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 14px 30px;
        cursor: pointer;
        width: 150px;
        height: 48px;
        background: #333333;
        border-radius: 8px;
        span{
          margin: 0px 16px;
          font-style: normal;
          font-weight: 600;
          font-size: 14px;
          line-height: 20px;
        }
        i{
          font-style: normal;
          font-weight: 900;
          font-size: 14px;
          line-height: 20px;
        }
      }
    }
    h2 {
      font-size: 24px;
    }

    .row-bg {
      //padding: 10px;
      margin-left: 0px !important;
      margin-right: 0px!important;
      .el-col {

        margin-bottom: 49px;
        height: 262px;
        /*width: 418px;*/
        //margin-right: 40px;
        //margin-bottom: 40px;

        .card {
          width: 100%;
          height: 100%;
          padding: 0;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
          border-radius: 8px;
          background-color: #333333;
          .type-label {
            font-family: Inter;
            font-style: normal;
            font-weight: 600;
            font-size: 24px;
            line-height: 24px;
            color: #FFFFFF;
            height: 70px;
            display: flex;
            align-items: center;
          }
          .type-count{
            display: flex;
            align-items: center;
            height: 122px;
          }
          .type-bottom{
            display: flex;
            align-items: center;
            height: 70px;
            font-size: 18px;
            font-weight: 400;
          }
          .flex-1{
            flex: none;
            width: 100%;
            align-items: center;
          }
          .flex{
            align-items: center;
            justify-content: center;

          }

          .num {
            display: block;
            color: #586069;
            font-family: Inter;
            font-style: normal;
            font-weight: 300;
            font-size: 64px;
            line-height: 64px;
            color: #FFFFFF;
            width: 100%;
            white-space:nowrap;
            overflow:hidden;
            text-overflow:ellipsis;
          }

          .icon-circle-up {
            display: inline-block;
            padding-right: 10px;
            color: #85E89D;
            font-size: inherit;
            font-weight: inherit;
          }
          .icon-circle-up-warn {
            display: inline-block;
            padding-right: 10px;
            color: #F97583;
            font-size: inherit;
            font-weight: inherit;
          }

          .update-num {
            color: #85E89D;
            font-size: inherit;
            font-weight: inherit;
          }
          .update-num-warm {
            color: #F97583;
            font-size: inherit;
            font-weight: inherit;
          }

          .ul-color {
            margin-top: 15px;
            width: 100%;
            ul {
              list-style: none;
              display: flex;

              li {
                width:8%;
                margin: 0px 1px;
                display: flex;
                flex-direction: column;

                span {
                  font-family: Inter;
                  font-style: normal;
                  font-weight: 600;
                  font-size: 8px;
                  line-height: 10px;
                  margin-bottom: 3px;

                  &:last-child {
                    display: block;
                    height: 10px;
                  }
                }

                &:nth-child(1) {
                  color: #DC241F;

                  span:last-child {
                    background: #DC241F;
                    border-bottom-left-radius: 3px;
                    border-top-left-radius: 3px;
                  }
                }

                &:nth-child(2) {
                  color: #FFCE00;

                  span:last-child {
                    background: #FFCE00;
                  }
                }

                &:nth-child(3) {
                  color: #0FD917;

                  span:last-child {
                    background: #0FD917;
                  }
                }

                &:nth-child(4) {
                  color: #FFAAF7;

                  span:last-child {
                    background: #FFAAF7;
                  }
                }

                &:nth-child(5) {
                  color: #FFE500;

                  span:last-child {
                    background: #FFE500;
                  }
                }

                &:nth-child(6) {
                  color: #FF5BEF;

                  span:last-child {
                    background: #FF5BEF;
                  }
                }

                &:nth-child(7) {
                  color: #97C0FF;

                  span:last-child {
                    background: #97C0FF;
                  }
                }

                &:nth-child(8) {
                  color: #CF80FF;

                  span:last-child {
                    background: #CF80FF;
                  }
                }

                &:nth-child(9) {
                  color: #F9A3A3;

                  span:last-child {
                    background: #F9A3A3;
                  }
                }

                &:nth-child(10) {
                  color: #86FF8B;

                  span:last-child {
                    background: #86FF8B;
                  }
                }

                &:nth-child(11) {
                  color: #BCCCD6;

                  span:last-child {
                    background: #BCCCD6;
                  }
                }

                &:nth-child(12) {
                  color: #FFAAF7;

                  span:last-child {
                    background: #FFAAF7;
                  }
                }

                &:nth-child(13) {
                  color: #00C2FF;

                  span:last-child {
                    background: #00C2FF;
                  }
                }

                &:nth-child(14) {
                  color: #2AF2B6;

                  span:last-child {
                    background: #2AF2B6;
                  }
                }

                &:last-child{
                  span:last-child{
                    border-top-right-radius: 3px;
                    border-bottom-right-radius: 3px;
                  }
                }

              }
            }
          }
          .account-ul-color {
            ul {
              list-style: none;
              display: flex;

              li {
                margin: 0px 1px;
                display: flex;
                flex-direction: column;
                span {
                  font-family: Inter;
                  font-style: normal;
                  font-weight: 600;
                  font-size: 8px;
                  line-height: 10px;
                  margin-bottom: 3px;
                  text-align: left;
                  width: 100%;
                  white-space:nowrap;
                  overflow:hidden;
                  text-overflow:ellipsis;
                  &:last-child {
                    display: block;
                    height: 10px;
                    background: #28A745;
                  }
                }

                &:nth-child(1) {
                  color: #28A745;

                  span:last-child {
                    background: #ade2aa;
                    border-bottom-left-radius: 3px;
                    border-top-left-radius: 3px;
                  }
                }

                &:nth-child(2) {
                  color: #79B8FF!important;
                  text-align: right;
                  span:last-child {
                    background: #79B8FF;
                  }
                }

                &:last-child{
                  span:last-child{
                    border-top-right-radius: 3px;
                    border-bottom-right-radius: 3px;
                  }
                }

              }
            }
            .little-num{
              font-family: Inter;
              font-style: normal;
              font-weight: 400;
              font-size: 18px;
              span{
                &.green{
                  color: #ade2aa;
                }
                &.blue{
                  color: #79B8FF;
                }
                &.white {
                  color: #FFFFFF;
                }
              }
              span + span {
                margin-left: 15px;
              }
            }
          }
          .wrap{
            flex-wrap: wrap;
            // margin-top: 15px;
          }
        }
      }
    }
    .on-duty-size{
      font-family: Inter;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      color: #FFFFFF;
      padding: 0 3px;
    }
  }
</style>
